import { useRef, useEffect } from 'react';
import style from './ErrorBox.module.css';

interface ErrorBoxPropsInterface {
  error?: string;
  onClose: () => void;
}

function ErrorBox(props: ErrorBoxPropsInterface) {
  const {
    error,
    onClose,
  } = props;
  const modalEl = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleOutsideClick(event: MouseEvent) {
      const target = event.target as HTMLElement;

      if (modalEl.current && !modalEl.current.contains(target)) {
        onClose();
      }
    }

    if (error) {
      document.addEventListener('click', handleOutsideClick, true);
      return () => {
        document.removeEventListener('click', handleOutsideClick, true);
      };
    }

    return undefined;
  }, [error, onClose, modalEl]);

  if (!error || error === '') {
    return null;
  }

  return (
    <div ref={modalEl} className={style.container}>
      {error}
    </div>
  );
}

ErrorBox.defaultProps = {
  error: '',
};

export default ErrorBox;
